<!--
    课程分享
    作用：展示课程列表数据
    功能：数据展示、数据操作
    说明：版本3.0
-->
<template>
  <div
    v-loading="isLoading"
    ref="page"
    class="package-list">
    <div
      ref="top"
      class="top-demo">
      <search-form
        :is-query.sync="listQuery"
        :form-data="formData"
        :is-add="false"
        style="flex:1"
        @onSearch="handlerSearch"/>
      <div class="btn-block">
        <el-button
          :disabled="!AuthCourseArr.length"
          size="medium"
          @click="handlerAuth">课程批量授权<span v-if="AuthCourseArr.length">({{ AuthCourseArr.length }})</span></el-button>
        <el-button
          size="medium"
          type="primary"
          @click="handlerCreate">新增课程</el-button>
      </div>
    </div>
    <el-table
      v-if="tableHeight"
      ref="table"
      :data="tableData"
      :height="tableHeight"
      class="table-demo"
      row-key="id"
      fit
      style="width: 100%;"
      @selection-change="selectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        :selectable="checkSelectable"
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        v-for="(item,index) in tableHead"
        :key="index"
        :label="item.label"
        :width="item.width"
        :prop="item.prop"
      />
      <el-table-column
        width="120px"
        label="上下架状态"
      >
        <template slot-scope="{row}">
          <span v-if="row.sale_status === 1">上架</span>
          <span v-else>下架</span>
          <el-switch
            :value="row.sale_status === 1"
            active-color="#13ce66"
            inactive-color="#e3e3e3"
            @change="changeCourseAuth(row.sale_status, row.id)"/>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="240px"
        class="orgin-btn"
      >
        <template slot-scope="scope">
          <!-- <el-link
            v-if="scope.row.sale_status === 1"
            size="small"
            @click="onBtns('putOff',scope.row)"
          >下架</el-link>
          <el-link
            v-else
            size="small"
            @click="onBtns('putOn',scope.row)"
          >上架</el-link>
          <i class="icon-splite">|</i> -->
          <el-link
            size="small"
            @click="onBtns('edit',scope.row)"
          >编辑</el-link>
          <i class="icon-splite">|</i>
          <el-link
            size="small"
            @click="onBtns('copy',scope.row)"
          >复制</el-link>
          <i class="icon-splite">|</i>
          <el-link
            size="small"
            @click="onBtns('del',scope.row)"
          >删除</el-link>
          <i class="icon-splite">|</i>
          <el-link
            size="small"
            @click="onBtns('editClassHours',scope.row)"
          >课时编辑</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      style="text-align: right;margin-top:20px"
      @current-change="getList"
    />
  </div>
</template>

<script>

import { tableHead, formData } from './fields';
// import GradeList from '../grade'
import { fetchPutOnList, fetchTag, updatePacketSale, copyPacket, delPacket } from '@/api/courseOn';
import searchForm from '@/components/AppFilter';

export default {
  name: 'PutOn',
  components: {
    searchForm,
  },
  data() {
    return {
      total: 0, // 分页总页数
      isLoading: false, // 是否加载
      isEdit: false, // 是否编辑
      tableHead,
      tableData: [],
      tableHeight: null,
      listQuery: {
        page: 1,
        per_page: 10,
      },
      formData,
      AuthCourseArr: [],
    };
  },
  mounted() {
    this.setTableHeight();
    this.init();
    window.onresize = () => {
      // const width = this.$refs.page.offsetWidth;
      // const cel = width > 1400 ? 180 : 280;
      setTimeout(() => {
        this.setTableHeight();
      }, 10);
    };
  },
  methods: {
    setTableHeight() {
      this.tableHeight = window.innerHeight - this.$refs.top.offsetHeight - 120;
    },
    async init() {
      this.isLoading = true;
      const stage = await fetchTag('stage');
      const subject = await fetchTag('subject');
      const stageArr = [];
      const subjectArr = [];
      stage.items.forEach((item) => {
        stageArr.push({ value: item.id, label: item.name });
      });
      subject.items.forEach((item) => {
        subjectArr.push({ value: item.id, label: item.name });
      });
      this.formData[0].options = stageArr;
      this.formData[1].options = subjectArr;
      this.getList();
    },
    getList() {
      const obj = { clients_id: this.$store.state.choicesSchool.id, ...this.listQuery };
      this.isLoading = true;
      fetchPutOnList(obj).then((res) => {
        this.tableData = res.items;
        this.total = res.meta.total;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handlerSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 新增课程
    handlerCreate() {
      this.$router.push('/putOn/addCourse');
    },
    onBtns(key, data) {
      switch (key) {
        case 'putOff': // 下架
          this.changeCourseAuth(2, data.id);
          break;
        case 'putOn': // 上架
          this.changeCourseAuth(1, data.id);
          break;
        case 'edit': // 编辑
          this.$router.push(`/putOn/addCourse?packetId=${data.id}`);
          break;
        case 'copy': // 复制
          this.setCopyPacket(data.id);
          break;
        case 'del': // 删除
          this.setDelPacket(data.id);
          break;
        case 'editClassHours': // 课时编辑
          this.$router.push(`/putOn/editClassHours?packetId=${data.id}`);
          break;
        default:
      }
    },
    // 课程上架/下架
    changeCourseAuth(type, id) {
      const formData = new FormData();
      const sale_status = type === 1 ? 2 : 1;
      formData.append('sale_status', sale_status);
      formData.append('id', id);
      const text = type === 1 ? '下架课程，将<strong style="color:red">无法上课</strong>，是否继续' : '上架课程，是否继续?';
      const title = type === 1 ? '下架' : '上架';
      this.$confirm(text, '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            updatePacketSale(this.$store.state.choicesSchool.id, formData)
              .then((res) => {
                done();
                if (res.status_code === 200) {
                  this.$message.success(`课程${title}成功!`);
                  this.getList();
                } else {
                  this.$message.error(res.message);
                }
                instance.confirmButtonLoading = false;
              })
              .catch((err) => {
                this.$message.error(err.message);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
        }).catch(() => {});
    },
    // 复制课程
    setCopyPacket(id) {
      const formData = new FormData();
      formData.append('src_id', id);
      copyPacket(this.$store.state.choicesSchool.id, formData).then(() => {
        this.$message.success('复制成功！');
        this.getList();
      }).catch((err) => {
        this.$message.error(err.message);
      });
    },
    // 删除
    setDelPacket(id) {
      this.$confirm('该操作将<strong style="color:red">删除</strong>课程，是否继续?', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            delPacket(this.$store.state.choicesSchool.id, id)
              .then((res) => {
                done();
                instance.confirmButtonLoading = false;
                if (res.status_code === 200) {
                  this.$message.success('删除成功!');
                  this.getList();
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.message);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
        }).catch(() => {});
    },
    // 选择复选框
    selectionChange(val) {
      console.log('勾选', val);
      const newArr = [];
      this.AuthCourseArr = val;
      val.forEach((item) => {
        const { id, name, code, detail_count, updated_at } = item;
        newArr.push({
          id, name, code, detail_count, updated_at,
        });
      });
      this.$store.dispatch('setCourseAuth', newArr);
      // sessionStorage.setItem('volumeAuth', JSON.stringify(newArr))
    },
    // 批量授权
    handlerAuth() {
      this.$router.push('/putOn/volumeAuth');
    },
    // 可选中条件
    checkSelectable(row) {
      return row.sale_status === 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.package-list{
  height: 100vh;
  width: 100%;
  flex:none!important;
  box-sizing: border-box;
}
.top-demo{
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .btn-block{
    width: 300px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/putOn/index.vue